import { HttpClient, HttpContext } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SPINNER_MESSAGE } from '../interceptors/loading-spinner.interceptor'
import { environment } from '../../../environments/environment'
import { API_KEY } from '../interceptors/api-key.interceptor'
import { registrationAuthorityApiName } from '../models/commercial-register-data'

@Injectable({
  providedIn: 'root',
})
export class CommercialRegisterService {
  private readonly httpClient = inject(HttpClient)
  private readonly baseUrl = environment.validationApiUrl

  getCompanyData({
    registrationType,
    registrationAuthorityName,
    registrationNumber,
  }: CompanyDataRequest): Observable<CompanyDataValidationResult[]> {
    return this.httpClient.get<CompanyDataValidationResult[]>(
      `${this.baseUrl}/commercial-register/${encodeURIComponent(registrationType)}/${encodeURIComponent(
        registrationAuthorityApiName(registrationAuthorityName)
      )}/${encodeURIComponent(registrationNumber)}`,
      {
        context: new HttpContext()
          .set(SPINNER_MESSAGE, 'Firmendaten werden abgerufen...')
          .set(API_KEY, environment.validationApiKey),
      }
    )
  }
}

export interface CompanyDataRequest {
  registrationType: string
  registrationAuthorityName: string
  registrationNumber: string
}

export interface CompanyDataValidationResult {
  name: string
  address: {
    houseNumber: string
    street: string
    postalCode: string
    city: string
  }
}
